<template>
	<v-container fluid class="ma-0 pa-0">
    <Header @currentGroup="currentGroupFunc" />
    <v-col class="pa-0" id="main_content_maxwidthset" cols="12">
			<v-col class="ma-0 pa-5" cols="12" align="center">
        <v-row class="ma-0 pa-0 mb-3" justify="space-between">
          <v-col class="ma-0 pa-0" cols="auto">
            <v-row class="ma-0 pa-0" align="center">
              {{tsg('selectSplitScreen')}} : 
              <v-menu offset-y :close-on-content-click="false" v-model="splitScreenSelectMenu">
                <template v-slot:activator="{on, attrs}">
                  <v-btn id="split_screen_select_menu" class="ml-2 text-none" v-bind="attrs" v-on="on">
                    <v-row class="ma-0 pa-0" justify="space-between">
                      <v-col class="ma-0 pa-0 pl-2 ellipsis" cols="11" id="select_menu_text">
                        {{selectedSplitScreen}}
                      </v-col>
                      <v-col class="ma-0 pa-0" cols="1" align-self="end">
                        <v-img src="@/assets/images/icon_arrow_down_small.png"></v-img>
                      </v-col>
                    </v-row>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item id="select_list_item" v-for="(item, index) in splitScreenList" :key="index" @click="closeNameChangeDialog(item.splitName)">
                    <v-row class="ma-0 pa-0" justify="space-between">
                      <v-col class="ma-0 pa-0 pl-2" cols="8" align-self="center">
                        <v-row class="ma-0 pa-0" justify="space-between">
                          <v-col class="ma-0 pa-0 pr-1" cols="2" align-self="center">
                            <v-img v-if="item.splitName == selectedSplitScreen" src="@/assets/images/icon_check.png"></v-img>
                          </v-col>
                          <v-col class="ma-0 pa-0 ellipsis" cols="10" style="text-align: left;max-width:200px;">
                            {{item.splitName}} 
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="ma-0 pa-0" cols="4">
                        <v-btn id="transparent_btn_select_small" elevation="0" @click="nameChangeDialogFunc(item.id, item.splitName)">
                          <v-img src="@/assets/images/icon_pen.png"></v-img>
                        </v-btn>
                        <v-btn id="transparent_btn_select_small" elevation="0" @click="deleteSplit(item.id)">
                          <v-img src="@/assets/images/close.png"></v-img>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-btn id="blue_btn" class="ml-2" @click="goCreateSplitScreen">
                {{tsg('createSplitScreen')}}
              </v-btn>
            </v-row>
          </v-col>
          <v-col class="ma-0 pa-0" cols="auto">
            <v-row class="ma-0 pa-0">
              <v-btn id="transparent_btn" elevation="0" @click="splitScreenDialogVisible = true">
                <v-img src="@/assets/images/icon_split_screen.png"></v-img>
              </v-btn>
              <v-btn id="transparent_btn" elevation="0" @click="handleFullScreen">
                <v-img src="@/assets/images/video_fullscreen.png"></v-img>
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
				
        <v-row id="cameras-area" class="ma-0 pa-0" v-if="!loading">
				  <v-col class="ma-0 pa-0" cols="12"
				  	v-if="viewCount == 4" :key="view4">
				  	<v-row class="ma-0 pa-2 full-height" justify="center">
              <v-col v-for="(item, index) in 2" :key="index" class="ma-0 pa-0" cols="auto">
                <v-col v-for="(item_nest, index_nest) in 2" :key="index_nest" class="ma-0 pa-0" cols="12">
                  <v-hover v-slot="{ hover }">
                    <v-col v-if="checkSplitScreenCameraList(index, index_nest, 2)" 
											id="camera_4box" class="ma-0 pa-0 ml-1 mr-1 mb-2">
                      <v-col id="camera_select_btn" class="ma-0 pa-0" cols="auto">
                        <v-btn v-if="hover" id="hover_btn" @click="showMenu(index_nest + 2 * index, 4)">
                          <v-img src="@/assets/images/dots.png"></v-img>
                        </v-btn>
				  				    </v-col>
				  				    <v-col id="camera_select_bottom_bar" class="ma-0 pa-0" cols="12">
                        {{getSplitName(index, index_nest, 2)}}
				  				    </v-col>
                      <SplitScreenHoverMenuList v-if="hover" video group
                                                :index="index" :indexCalc="2"
                                                :index_nest="index_nest" :players="players"
                                                :splitScreenCameraList="splitScreenCameraList"
                                                :viewCount="viewCount"
                                                :selectedSplitScreen="selectedSplitScreen" :currentGroupId="currentGroupId"
                                                @deleteCamera="deleteSplitCamera"
                                                @openCameraSearchDialog="openCameraSearchDialogFunc" />
                      <v-progress-linear
                        :id="'example-4-progress' + (index_nest + 2 * index)"
                        indeterminate
                        color="blue"
                      />
                      <video :id="'example-4-video' + (index_nest + 2 * index)" width=550 height=350 
												muted style="object-fit: fill;"
                        class="ma-2 pa-0 video-js vjs-default-skin vjs-big-play-centered vjs-custom">
                      </video>
                    </v-col>
                    <v-col v-else id="camera_4box" class="ma-0 pa-0 ml-1 mr-1 mb-2">
				  				    <v-col id="camera_select_btn" class="ma-0 pa-0" cols="auto">
                        <v-btn v-if="hover" id="hover_btn" @click="showMenu(index_nest + 2 * index, 4)">
                          <v-img src="@/assets/images/dots.png"></v-img>
                        </v-btn>
				  				    </v-col>
                      <SplitScreenHoverMenuList v-if="hover" group :index="index" :indexCalc="2"
                                                :index_nest="index_nest" :players="players"
                                                :splitScreenCameraList="splitScreenCameraList"
                                                :viewCount="viewCount"
                                                :selectedSplitScreen="selectedSplitScreen" :currentGroupId="currentGroupId"
                                                @deleteCamera="deleteSplitCamera"
                                                @openCameraSearchDialog="openCameraSearchDialogFunc" />
                      <v-progress-linear
                        :id="'example-4-progress' + (index_nest + 2 * index)"
                        indeterminate
                        color="blue"
                      />
                      <video :id="'example-4-video' + (index_nest + 2 * index)" width=550 height=350 
												muted style="object-fit: fill;"
                        class="ma-2 pa-0 video-js vjs-default-skin vjs-big-play-centered vjs-custom">
                      </video>
                      <v-col :id="'no-data-video' + (index_nest + 2 * index)" class="video_grey_box" style="display:flex;">
                        {{t('noData')}}
                      </v-col>
                    </v-col>
                  </v-hover>
                </v-col>
              </v-col>
				  	</v-row>
				  </v-col>

				  <v-col class="ma-0 pa-0" cols="12"
				  	v-if="viewCount == 9" :key="view9">
				  	<v-row class="ma-0 pa-2 full-height" align="center">
              <v-col v-for="(item, index) in 3" :key="index" class="ma-0 pa-0" cols="4">
                <v-col v-for="(item_nest, index_nest) in 3" :key="index_nest" class="ma-0 pa-0 pr-1 pl-1 mb-2" cols="12">
                  <v-hover v-slot="{ hover }">
                    <v-col v-if="checkSplitScreenCameraList(index, index_nest, 3)" 
											id="camera_9box" class="ma-0 pa-0">
                      <v-col id="camera_select_btn" class="ma-0 pa-0" cols="auto">
                        <v-btn v-if="hover" id="hover_btn" @click="showMenu(index_nest + 3 * index, 9)">
                          <v-img src="@/assets/images/dots.png"></v-img>
                        </v-btn>
				  				    </v-col>
                      <v-col id="camera_select_bottom_bar" class="ma-0 pa-0" cols="12">
                        {{getSplitName(index, index_nest, 3)}}
				  				    </v-col>
                      <SplitScreenHoverMenuList v-if="hover" video group
                                                :index="index" :indexCalc="3"
                                                :index_nest="index_nest" :players="players"
                                                :splitScreenCameraList="splitScreenCameraList"
                                                :viewCount="viewCount"
                                                :selectedSplitScreen="selectedSplitScreen" :currentGroupId="currentGroupId"
                                                @deleteCamera="deleteSplitCamera"
                                                @openCameraSearchDialog="openCameraSearchDialogFunc" />
                      <v-progress-linear
                        :id="'example-9-progress' + (index_nest + 3 * index)"
                        indeterminate
                        color="blue"
                      />
                      <video :id="'example-9-video' + (index_nest + 3 * index)" width=550 height=350 
												muted style="object-fit: fill;"
                        class="ma-2 pa-0 video-js video-js-9 vjs-default-skin vjs-big-play-centered vjs-custom">
                      </video>
                    </v-col>
                    <v-col v-else id="camera_9box" class="ma-0 pa-0">
				  				    <v-col id="camera_select_btn" class="ma-0 pa-0" cols="auto">
                        <v-btn v-if="hover" id="hover_btn" @click="showMenu(index_nest + 3 * index, 9)">
                          <v-img src="@/assets/images/dots.png"></v-img>
                        </v-btn>
				  				    </v-col>
                      <SplitScreenHoverMenuList v-if="hover" group :index="index" :indexCalc="3"
                                                :index_nest="index_nest" :players="players"
                                                :splitScreenCameraList="splitScreenCameraList"
                                                :viewCount="viewCount"
                                                :selectedSplitScreen="selectedSplitScreen" :currentGroupId="currentGroupId"
                                                @deleteCamera="deleteSplitCamera"
                                                @openCameraSearchDialog="openCameraSearchDialogFunc" />
                      <v-progress-linear
                        :id="'example-9-progress' + (index_nest + 3 * index)"
                        indeterminate
                        color="blue"
                      />
                      <video :id="'example-9-video' + (index_nest + 3 * index)" muted
												style="object-fit: fill;"
                        class="ma-2 pa-0 video-js video-js-9 vjs-default-skin vjs-big-play-centered vjs-custom">
                      </video>
                      <v-col :id="'no-data-video' + (index_nest + 3 * index)" class="video_grey_box" style="display:flex;">
                        {{t('noData')}}
                      </v-col>
                    </v-col>
                  </v-hover>
                </v-col>
              </v-col>
				  	</v-row>
				  </v-col>

				  <v-col class="ma-0 pa-0" cols="12"
				  	v-if="viewCount == 16" :key="view16">
				  	<v-row class="ma-0 pa-2 full-height" align="center">
              <v-col v-for="(item, index) in 4" :key="index" class="ma-0 pa-0" cols="3">
                <v-col v-for="(item_nest, index_nest) in 4" :key="index_nest" class="ma-0 pa-0 pr-1 pl-1 mb-2" cols="12">
                  <v-hover v-slot="{ hover }">
                    <v-col v-if="checkSplitScreenCameraList(index, index_nest, 4)" 
											id="camera_16box" class="ma-0 pa-0">
                      <v-col id="camera_select_btn" class="ma-0 pa-0" cols="auto">
                        <v-btn v-if="hover" id="hover_btn" @click="showMenu(index_nest + 4 * index, 16)">
                          <v-img src="@/assets/images/dots.png"></v-img>
                        </v-btn>
				  				    </v-col>
                      <v-col id="camera_select_bottom_bar" class="ma-0 pa-0" cols="12">
                        {{getSplitName(index, index_nest, 4)}}
				  				    </v-col>
                      <SplitScreenHoverMenuList v-if="hover" video group
                                                :index="index" :indexCalc="4"
                                                :index_nest="index_nest" :players="players"
                                                :splitScreenCameraList="splitScreenCameraList"
                                                :viewCount="viewCount"
                                                :selectedSplitScreen="selectedSplitScreen" :currentGroupId="currentGroupId"
                                                @deleteCamera="deleteSplitCamera"
                                                @openCameraSearchDialog="openCameraSearchDialogFunc" />
                      <v-progress-linear
                        :id="'example-16-progress' + (index_nest + 4 * index)"
                        indeterminate
                        color="blue"
                      />
                      <video :id="'example-16-video' + (index_nest + 4 * index)" width=550 height=350 
												muted style="object-fit: fill;"
                        class="ma-2 pa-0 video-js video-js-9 vjs-default-skin vjs-big-play-centered vjs-custom">
                      </video>
                    </v-col>
                    <v-col v-else id="camera_16box" class="ma-0 pa-0">
                      <v-col id="camera_select_btn" class="ma-0 pa-0" cols="auto">
                        <v-btn v-if="hover" id="hover_btn" @click="showMenu(index_nest + 4 * index, 16)">
                          <v-img src="@/assets/images/dots.png"></v-img>
                        </v-btn>
				  				    </v-col>
                      <SplitScreenHoverMenuList v-if="hover" group :index="index" :indexCalc="4"
                                                :index_nest="index_nest" :players="players"
                                                :splitScreenCameraList="splitScreenCameraList"
                                                :viewCount="viewCount"
                                                :selectedSplitScreen="selectedSplitScreen" :currentGroupId="currentGroupId"
                                                @deleteCamera="deleteSplitCamera"
                                                @openCameraSearchDialog="openCameraSearchDialogFunc" />
                      <v-progress-linear
                        :id="'example-16-progress' + (index_nest + 4 * index)"
                        indeterminate
                        color="blue"
                      />
                      <video :id="'example-16-video' + (index_nest + 4 * index)" muted
												style="object-fit: fill;"
                        class="ma-2 pa-0 video-js video-js-9 vjs-default-skin vjs-big-play-centered vjs-custom">
                      </video>
                      <v-col :id="'no-data-video' + (index_nest + 4 * index)" class="video_grey_box" style="display:flex;">
                        {{t('noData')}}
                      </v-col>
                    </v-col>
                  </v-hover>
                </v-col>
              </v-col>
				  	</v-row>
				  </v-col>
        </v-row>
				<v-row class="ma-0 pa-0" v-else>
					<v-col class="ma-0 pa-10 mt-10" cols="12">
						<v-progress-circular indeterminate color="white"
              :width="6" :size="50"></v-progress-circular>
					</v-col>
				</v-row>
			</v-col>
		</v-col>
    <CameraSearchDialog :dialogVisible="cameraSearchDialogVisible" :storeListData="storeList" 
			:checkBoxVisible="checkable" :storeInGroupData="currentGroup"
      @visible="cameraSearchDialogVisibleFunc" @selectedCamera="modifySelectedCameraFunc" />
    <CameraTourDialog :dialogVisible="cameraTourDialogVisible"
      @visible="cameraTourDialogVisibleFunc"/>
    <NameChangeDialog :dialogVisible="nameChangeDialogVisible" :editType="editNameType"
      :currentId="currentId" :currentName="currentName"
      @nameUpdate="nameUpdateFunc" @visible="nameChangeDialogVisibleFunc"/>
    <SplitScreenDialog :dialogVisible="splitScreenDialogVisible" :viewCount="viewCount"
      @visible="splitScreenDialogVisibleFunc" @selectedViewCount="selectedViewCountFunc" />
	</v-container>
</template>

<script>
import mixin from '@/mixin';
import splitScreenMixin from '../mixin/splitScreen';
import peerMixin from '@/views/player/mixin/peer';
import Header from '../Header.vue';
import 'video.js/dist/video-js.css';
import videojs from 'video.js';
import ja from 'video.js/dist/lang/ja.json';
import 'videojs-contrib-hls';
import CameraSearchDialog from '@/components/dialogs/CameraSearchDialog.vue';
import CameraTourDialog from '@/components/dialogs/CameraTourDialog.vue';
import NameChangeDialog from '@/components/dialogs/NameChangeDialog.vue';
import SplitScreenDialog from '@/components/dialogs/SplitScreenDialog.vue';
import SplitScreenHoverMenuList from "@/components/SplitScreenHoverMenuList.vue";
import { isIOS, isSafari } from 'mobile-device-detect';
import rtcViewer from '@/api/webrtc';
import Offline from '@/api/offline';
import { ApiVersion } from '@/constants';

export default {
	components: {
    SplitScreenHoverMenuList,
		Header, CameraSearchDialog, CameraTourDialog, NameChangeDialog, SplitScreenDialog
	},
	mixins: [mixin.common, splitScreenMixin, peerMixin],
	data: () => ({
    currentGroupId: '',
		viewCount: 4,
    cameraSearchDialogVisible: false,
    cameraTourDialogVisible: false,
    nameChangeDialogVisible: false,
    splitScreenDialogVisible: false,
    splitScreenSelectMenu: false,
    splitScreenList: [],
    storeList: [],
    selectedSplitScreen: '',
    splitScreenCameraList: [],
    streamingUrlList: [],
    streamingCount: 0,
    selectedVideo: 'フロア1',
    menuShowing: false,
		players: [],
    checkable: false,
    currentItemIndex: 0,
    splitGroupId: '',
    editNameType: 'splitlist',
    currentName: '',
    currentId: '',
    view4: 0,
    view9: 10,
    view16: 100,
    playerOptions: { language: 'ja', languages: { ja }, autoplay: 'muted' },
    currentGroup: [],
		loading: false,
    pausePlayInterval: null, // 초기화
    webrtcConnections: [],
	}),
	created() {
    if(this.$route.query.view != undefined)
		  this.viewCount = Number(this.$route.query.view);
		this.currentGroupId = this.$route.query.groupId;
	},
  async mounted() {
    await this.getSplitList();
    await this.getBrandData();
    if (isSafari) {
      this.initializePausePlayInterval();
    }
    window.addEventListener('beforeunload', () => {
      this.closeAndDisposeAll();
    });
  },
  watch: {
    selectedSplitScreen: function(item) {
      this.$store.commit('setSelectedSplitScreen', item);
      this.getSplitListCameras(0);
    }
  },
	beforeDestroy() {
    this.closeAndDisposeAll();
  },
	methods: {
		/*
		* 함수가 없는경우 ../mixin/splitScreen.js 에서 찾을것
		*/
		tsg(t) {
      return this.$t("lang.group." + t);
    },
    cameraSearchDialogVisibleFunc(visible) {
      this.cameraSearchDialogVisible = visible;
      if(visible == false) this.showMenu(null, this.viewCount);
    },
    cameraTourDialogVisibleFunc(visible) {
      this.cameraTourDialogVisible = visible;
    },
    nameChangeDialogVisibleFunc(visible) {
      this.nameChangeDialogVisible = visible;
    },
    showNameChangeDialog() {
      this.nameChangeDialogVisible = true;
      this.splitScreenSelectMenu = true;
    },
    closeNameChangeDialog(value) {
      if(this.nameChangeDialogVisible != true) this.splitScreenSelectMenu = false;
      this.selectedSplitScreen = value;
    },
    nameUpdateFunc(item) {
      let currentIndex = this.splitScreenList.findIndex(r => r.id === item.id);
      this.splitScreenList[currentIndex].splitName = item.splitName;
      this.selectedSplitScreen = item.splitName;
    },
    nameChangeDialogFunc(id, name) {
      this.editNameType = 'splitlist';
      this.currentId = id;
      this.currentName = name;
      this.nameChangeDialogVisible = true;
      this.splitScreenSelectMenu = true;
      event.stopPropagation();
    },
    selectedViewCountFunc(value) {
      if(value != this.viewCount) {
				try {
					// viewCount 변경 전에 재생되고 있는 player들을 dispose 해야 새로 스트리밍 되는 비디오 재생 가능
					for(let i = 0; i < this.players.length; i++) {
						// 중간에 스트리밍 되지 않은 비디오는 dispose 하면 에러가 나기 때문에 if문으로 처리
						if(this.players[i]) this.players[i].dispose();
					}
					this.players = [];
				} catch(e) {
          console.log(e)
        }
        this.viewCount = value;

				const idx = this.splitScreenList.findIndex(r => r.splitName === this.selectedSplitScreen);
				this.networkController.updateCameraSplit({
					viewCount: value,
					splitName: this.selectedSplitScreen
				}, this.splitScreenList[idx].id)
        .then(async (res) => {
					//rerendering을 위한 key값 변경
					if(value == 9) this.view9 += 1;
					else if(value == 16) this.view16 += 1;
					else this.view4 += 1;
					this.getSplitListCameras(value);   
        }).catch(error => { });
      }
    },
    splitScreenDialogVisibleFunc(visible) {
      this.splitScreenDialogVisible = visible;
    },
    async modifySelectedCameraFunc(selectedCamera) {
      if(selectedCamera != null) {
        this.closeAndDisposeAll();
        this.$vloading.show();
        let addParams = {
          index: this.currentItemIndex,
          contractCd: selectedCamera.contractCd,
          portNo: selectedCamera.portNo,
          thingType: selectedCamera.thingType
        };
        await this.networkController.upsertCameraSplitCamera(addParams, this.splitGroupId)
        .then((res) => {
          this.cameraList = res.data.cameras;
          this.$vloading.hide();
					this.getSplitListCameras(0);
        }).catch(error => {
          this.$vloading.hide();
        });
      }
    },
    goCreateSplitScreen() {
      this.pushRoute('/split-screen/view-select', {groupId: this.currentGroupId});
    },
    stopProgressBar(id) {
      const progress = document.getElementById(id);
      if (progress) progress.style.display = 'none';
    },
    async createRTCPlayer(player, webrtcInforms, streamingCount, cameraInfo) {
      this.webrtcConnections.push(webrtcInforms);
      await rtcViewer.startViewer(player, webrtcInforms);
      if (cameraInfo.apiVersion > ApiVersion.NO_DATA_CH) {
        const that = this.getOfflineThat(webrtcInforms, cameraInfo);
        const offline = new Offline(that, rtcViewer);
        offline.viewer.dataChannel.onopen = () => {
          offline.sendMessage('live');
        }
        offline.viewer.dataChannel.onmessage = (evt) => {
          offline.receiveMessageSimple(evt);
        }
      }
      if(cameraInfo.webrtc.playback && cameraInfo.webrtc.playback.supported) {
        const that = this.getOfflineThat(webrtcInforms, cameraInfo);
        const offline = new Offline(that, rtcViewer);
        offline.viewer.dataChannel.onopen = () => {
          offline.sendMessage('live');
        }
        offline.viewer.dataChannel.onmessage = (evt) => {
          offline.receiveMessageSimple(evt);
        }
      }
      this.players[streamingCount] = videojs(player.id, this.playerOptions, () => {
        let duration = 1000;
        if (isIOS) duration = 2000;
        setTimeout(() => {
          this.stopProgressBar(`example-${this.viewCount}-progress${streamingCount}`);
          this.players[streamingCount].el_.querySelector('video').src = null;
          this.players[streamingCount].el_.querySelector('video').srcObject = player.srcObject;
          this.players[streamingCount].play();
        }, duration);
      });
      this.streamingCount = this.streamingCount + 1;
    },
    createPlayer(videoSourceUrl, streamingCount) {
      const vm = this;
      this.players[streamingCount] = videojs(`example-${this.viewCount}-video${streamingCount}`, this.playerOptions, function onPlayerReady() {
			  this.src({
					src: videoSourceUrl,
					type: 'application/x-mpegURL'
				});
        setTimeout(() => {
          vm.stopProgressBar(`example-${vm.viewCount}-progress${streamingCount}`);
          this.play(); 
        }, 500);
        this.on('error', function(event) {
          console.log(event);
        });
        this.on('waiting', () => {
          setTimeout(() => {
            if (this.readyState() < 3) {
              vm.restartPlayer(streamingCount);
            }
          }, 20000);
        });
      });
      this.streamingCount = this.streamingCount + 1;
    },
    openCameraSearchDialogFunc(index) {
      this.currentItemIndex = index;
      this.cameraSearchDialogVisible = true;
    },
    openCameraSearchDialog(index) {
			console.log(index)
			console.log(this.players[index])
      this.currentItemIndex = index;
      this.cameraSearchDialogVisible = true;
    },
    currentGroupFunc(item) {
      this.currentGroup = item;
    },    
    closeAndDisposeAll() {
      try {
        for (let i = 0; i < this.players.length; i++) {
          // 중간에 스트리밍 되지 않은 비디오는 dispose 하면 에러가 나기 때문에 if문으로 처리
          if (this.players[i]) this.players[i].dispose();
        }
        if (this.pausePlayInterval) {
          clearInterval(this.pausePlayInterval);
        }
      } catch (e) {
        console.log(e)
      }
      this.webrtcConnections.forEach(informs => {
        rtcViewer.stopViewer(informs);
      })
      this.webrtcConnections = [];
    },
    changeCameraBoxStyle(isAdd) {
      const cameras = document.querySelectorAll(`#cameras-area #camera_${this.viewCount}box`);
      const className = `camera_full_${this.viewCount}box`;
      cameras.forEach(ele => isAdd ? ele.classList.add(className) : ele.classList.remove(className));
      if (this.viewCount === 4) {
        const videos = document.querySelectorAll(`#cameras-area #camera_${this.viewCount}box video`);
        const style = `video-js-${this.viewCount}`;
        videos.forEach(ele => isAdd ? ele.classList.add(style) : ele.classList.remove(style));
      }
      if (isAdd) {
        document.addEventListener('fullscreenchange', this.exitFullScreen);
        document.addEventListener('mozfullscreenchange', this.exitFullScreen);
        document.addEventListener('webkitfullscreenchange', this.exitFullScreen);
        document.addEventListener('MSFullscreenChange', this.exitFullScreen);
      } else {
        document.removeEventListener('fullscreenchange', this.exitFullScreen);
        document.removeEventListener('moxfullscreenchange', this.exitFullScreen);
        document.removeEventListener('webkitfullscreenchange', this.exitFullScreen);
        document.removeEventListener('MSFullscreenChange', this.exitFullScreen);
      }
    },
    exitFullScreen() {
      if (!document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
        this.changeCameraBoxStyle(false);
      }
    },
    // cameras-area를 fullscreen으로 변경하는 메소드
    handleFullScreen() {
      const elem = document.getElementById('cameras-area');
      this.changeCameraBoxStyle(true);
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }
    },
	}
}
</script>

<style lang="scss" scoped>
.camera_full_4box {
  height: 49vh !important;
  min-height: 49vh !important;
  min-width: 49vw !important;
}
.camera_full_9box {
  height: 33vh !important;
  min-height: 33vh !important;
}
.camera_full_16box {
  height: 24vh !important;
  min-height: 24vh !important;
}
#camera_4box {
	background-color: #4E4E4E;
	width: 98%;
	height: 15rem;
	min-height: 15rem;
	position: relative;
}
#camera_9box {
	background-color: #4E4E4E;
	width: 100%;
	height: 12rem;
	min-height: 12rem;
	position: relative;
}
#camera_16box {
	background-color: #4E4E4E;
	width: 100%;
	height: 10rem;
	min-height: 10rem;
	position: relative;
}
#camera_select_btn {
	position: absolute;
	top: 4%;
  right: 2%;
	z-index: 3;
}
#transparent_btn {
  background-color: transparent;
  max-width: 4em;
  min-width: 4em;
}
#transparent_btn_select_small {
  background-color: transparent;
  max-width: 3em;
  min-width: 3em;
}
#camera_select_bottom_bar {
  position: absolute;
  bottom: 0%;
  text-align: left;
  padding-left: 1em !important;
  font-size: 0.8em;
  z-index: 3;
  background-color: rgba(0, 0, 0, 0.7);
  color: #A8A8A8;
}
#camera_menu_list {
  border-radius: 0.3em;
  border: 1px solid #4A4A4A;
}
.v-list {
  background: #171921;
	border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item{
    min-height: 0px;
    color: white !important;
  }
  .v-list-item__content{
    color: white;
    padding: 5px 0;
  }
}
#split_screen_select_menu {
  background-color: transparent;
  border: 1px solid #4A4A4A;
  color: white;
  height: 2.7em;
  width: 20em;
  justify-content: start;
}
#select_list_item {
  padding: 0px !important;
}
#select_menu_text {
  text-align: start;
	max-width: 185px;
}
#hover_btn {
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  min-width: 3em;
  max-width: 3em;
}
.video-js {
	width: 100%;
  height: 15rem;
	min-width: 30rem;
	min-height: 15rem;
  top: 0px;
  left: 0px;
  padding: 0px;
  margin: 0px !important;
}
.video-js-9 {
	width: 100%;
  height: 100%;
	min-width: 0;
	min-height: 0;
}
.video-js-4 {
  min-height: 49vh;
}
.video_grey_box {
  z-index:1;
  position:absolute;
  justify-content: center;
  align-items: center;
  display: none;
  background: grey;
  height: 100%;
  top: 0px;
}
#middle_divider {
	background-color: #4C4C4C;
}
</style>
